import { render, staticRenderFns } from "./ThirdPartyCompanyAssignedIssuesList.vue?vue&type=template&id=176919ad&scoped=true"
import script from "./ThirdPartyCompanyAssignedIssuesList.vue?vue&type=script&lang=ts"
export * from "./ThirdPartyCompanyAssignedIssuesList.vue?vue&type=script&lang=ts"
import style0 from "./ThirdPartyCompanyAssignedIssuesList.vue?vue&type=style&index=0&id=176919ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176919ad",
  null
  
)

export default component.exports